import { render, staticRenderFns } from "./NodeParent.vue?vue&type=template&id=4834fa4e"
import script from "./NodeParent.vue?vue&type=script&lang=js"
export * from "./NodeParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports